<div class="ai-card" [style.border-top-color]="accumulatedColor()">
    <span class="ai-card__title">{{ name() }}</span>

    <div class="ai-card__stats">
        @for (metric of metrics(); track metric.label; let first = $first) {
            <div class="ai-card__metric">
                <div class="ai-card__metric-head">
                    <span class="ai-card__metric-label">{{ metric.label | translate }}</span>
                    <span class="ai-card__metric-value" [style.color]="metric.color">
                        @if (metric.progress > 0) {
                            <adaa-count-up [total]="metric.value!" [fontSize]="valueFontSize" />
                        } @else {
                            {{ metric.value | percentageValue }}
                        }
                    </span>
                </div>

                <span
                    class="ai-card__bar"
                    [class.ai-card__bar--lead]="first"
                    role="progressbar"
                    aria-valuemin="0"
                    aria-valuemax="100"
                    [attr.aria-valuenow]="metric.progress"
                    [attr.aria-label]="metric.label | translate"
                >
                    <span [style.width.%]="metric.progress" [style.background-color]="metric.color"></span>
                </span>
            </div>
        }
    </div>
</div>
